import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryRushCapacitySlot implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fFactory: string,
    private fProduct: string,
    private fType: string,
    private fCapacity: number
  ) {
    [fId, fFactory, fProduct, fType, fCapacity].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get factory(): string {
    return this.fFactory;
  }

  get product(): string {
    return this.fProduct;
  }

  get type(): string {
    return this.fType;
  }

  get capacity(): number {
    return this.fCapacity;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
